import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { issnCategoryList } from '@/module/Journal';

import { identitySchema } from '@/core/components';

export const issnSchema = z.object({
  code: z.string().regex(new RegExp('[0-9]{4}-[0-9X]{4}')),
  category: z.enum(issnCategoryList),
});

export const journalSchema = z.object({
  title: z.string().min(3),
  language: identitySchema,
  publisher: identitySchema,
  bdis: z.array(identitySchema),
  issn: z.array(issnSchema),
});

export const defaultJournalValues: DefaultValues<JournalSchema> = {
  title: '',
  bdis: [],
  issn: [],
};

export type JournalSchema = z.infer<typeof journalSchema>;
export type IssnSchema = z.infer<typeof issnSchema>;
